import branding from "../branding/branding"

export const homePageRoute: string = "/"
export const errorPageRoute: string = "/error"
export const profilePageRoute: string = "/profile"
export const categoriesPageRoute: string = "/categories"
export const licencesPageRoute: string = branding.configuration.sidebar.urlLicences
export const linksPageRoute: string = "/links"
export const productsPageRoute: string = "/products"
export const productsForCollectionsPageRoute: string = "/productsforcollections"
export const trademarksPageRoute: string = "/trademarks"
export const teamPageRoute: string = "/team"
export const multimediaPageRoute: string = "/multimedia"
export const exhibitorNewsPageRoute: string = "/exhibitornews"
export const organizerNewsPageRoute: string = "/organizernews"
export const storyNewsPageRoute: string = "/stories"
export const eventDatesPageRoute: string = "/eventdates"
export const showroomsPageRoute: string = "/showrooms"
export const couponsPageRoute: string = "/coupons"
export const jobsPageRoute: string = "/jobs"
export const notificationTemplatesPageRoute: string = "/notifications"
export const printPageRoute: string = "/print"
